/**
 * Threads the accumulated parent world-Y and effective Z through a y-sort
 * subtree, so each descendant computes its sort key.
 */
import { createContext, useContext } from 'react';
// The walk starts at 0, not at the ambient `EffectiveZContext`, so a y-sort root
// under a z_index'd ancestor buckets from 0 while a plain CanvasItem there does
// not. Only the tile-group path, which reads this carrier, shows it.
const YSortContext = createContext({
    parentWorldY: 0,
    parentEffectiveZ: 0,
});
YSortContext.displayName = 'YSortContext';
export function useYSortContext() {
    return useContext(YSortContext);
}
//# sourceMappingURL=YSortContext.js.map